module.exports = __webpack_public_path__ + "048e7a244bf5058f34d07437dd560789.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-4.svg
// module id = 576
// module chunks = 0